import {IDepartmentList } from "store/StateInterfaces";

export default function departmentListToMap(departmentList: IDepartmentList[]) {
    let departmentMap = new Map<number, IDepartmentList>();
    departmentList.forEach((department) => {
        departmentMap.set(department.id, department);
    });
    return departmentMap;
};